import { StyledButtonAsLink } from '../primitives/styled-button';
import Container from '@atoms/Container';
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags';
import RichTextEditorStyles from '@utils/RichTextEditorStyles';
import React from 'react';
import SvgSafeGatsbyImage from '../atoms/SvgSafeGatsbyImage';
import Nearest from '../franchise/nearest';
import { colors } from '../primitives/colors';
import { breakpoints } from '../primitives/tokens';
import { useMicrosite } from '../../contexts/franchise/microsite-context';

const HeroHeading = ({ shouldRenderH1, children, ...props }) => {
    return shouldRenderH1 ? <h1 {...props}>{children}</h1> : <h2 {...props}>{children}</h2>;
};

const FullwidthHero = ({ data }) => {
    const {
        button_link, copy, image, heading, subheading, has_location_widget,
    } = data;
    const hasImage = !!image?.url;
    const { isMicrosite } = useMicrosite();

    return (
        <section css={{
            padding: '100px 0 70px',
            position: 'relative',
            [breakpoints.mb]: {
                padding: '48px 0 0',
            },
        }}
        >
            {hasImage && (
                <SvgSafeGatsbyImage
                    css={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: 'calc(100% - 180px)',
                        [breakpoints.tb]: {
                            height: 'calc(100% - 90px)',
                        },
                        [breakpoints.mb]: {
                            height: '100%',
                        },
                    }}
                    image={image}
                />
            )}
            <Container css={{
                position: 'relative',
            }}
            >
                <div css={{
                    paddingBottom: has_location_widget ? '48px' : '0',
                    color: hasImage ? colors.shadesWhite : 'unset',
                    [breakpoints.mb]: {
                        paddingBottom: has_location_widget ? '32px' : '0',
                    },
                }}
                >
                    <HeroHeading css={styles.heroHeading} shouldRenderH1={!isMicrosite}>{apCaseOnlyTitleTags(heading)}</HeroHeading>
                    {subheading && (
                        <h2 css={styles.heroSubheading}>{apCaseOnlyTitleTags(subheading)}</h2>
                    )}
                    <div
                        css={[RichTextEditorStyles, styles.heroCopy]}
                        dangerouslySetInnerHTML={{ __html: copy }}
                    />
                    {button_link?.title && (
                        <div css={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '40px',
                        }}>
                            <StyledButtonAsLink to={button_link.href}>{button_link.title}</StyledButtonAsLink>
                        </div>
                    )}
                </div>
            </Container>
            <div css={{
                position: 'relative'
            }}>
                <Nearest />
            </div>
        </section>
    );
};

const styles = {
    heroHeading: {
        maxWidth: "56rem",
        fontSize: "2.25rem",
        lineHeight: "2.5rem",
        fontWeight: 300,
        textAlign: "center",
        maxWidth: "56rem",
        marginRight: "auto",
        marginLeft: "auto",
        "@media (min-width: 768px)": {
            fontSize: "3rem",
            lineHeight: 1,
        },
        "@media (min-width: 1024px)": {
            fontSize: "75px",
        },
    },
    heroSubheading: {
        fontSize: "2.25rem",
        lineHeight: "2.5rem",
        fontWeight: 300,
        textAlign: "center",
        marginTop: "1.5rem",
        maxWidth: "56rem",
        "@media (min-width: 1024px)": {
            fontSize: "52px",
            marginTop: "2rem",
        },
    },
    heroCopy: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        textAlign: "center",
        letterSpacing: "0.025em",
        lineHeight: 1.625,
        maxWidth: "42rem",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "1.5rem",
        "@media (min-width: 1024px)": {
            fontSize: "1.5rem",
            lineHeight: "2rem",
            marginTop: "2rem",
            marginBottom: "2.25rem",
        },
    }
};

export default FullwidthHero;